var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("TablePage", {
        ref: "table",
        attrs: { treeCode: _vm.treeCode },
        on: { resetTrees: _vm.reset },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }